import { observer } from 'mobx-react-lite'
import { type JobCapturedInformationViewModel } from '@/features/jobs/details/JobCapturedInformationViewModel'
import { EditPersonalProfileDialogContainer } from '@/features/jobs/info-gathering/individual-info/components/EditPersonalProfileDialog/EditPersonalProfileDialogContainer'
import { EditBusinessProfileDialogContainer } from '@/features/jobs/info-gathering/business-info/components/EditBusinessProfileDialog/EditBusinessProfileDialogContainer'
import { EditRefundDialogContainer } from '@/features/jobs/info-gathering/tax-refund-method/components/EditRefundDialog/EditRefundDialogContainer'

export interface InfoGatheringDialogsContainerProps {
  vm: JobCapturedInformationViewModel
}

/**
 * Container component for the info gathering edit dialogs.
 */
export const InfoGatheringDialogsContainer = observer(
  function InfoGatheringDialogsContainer({
    vm,
  }: InfoGatheringDialogsContainerProps) {
    return (
      <>
        {vm.editPersonalProfileDialogVm && (
          <EditPersonalProfileDialogContainer
            vm={vm.editPersonalProfileDialogVm}
          />
        )}
        {vm.editBusinessProfileDialogVm && (
          <EditBusinessProfileDialogContainer
            vm={vm.editBusinessProfileDialogVm}
          />
        )}
        {vm.editRefundDialogVm && (
          <EditRefundDialogContainer vm={vm.editRefundDialogVm} />
        )}
      </>
    )
  },
)
